import BaseDialogContentText from '@material-ui/core/DialogContentText'

const DialogContentText = BaseDialogContentText

export default DialogContentText
